import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacings.spacing_xs};
  font-family: "Montserrat";
  font-weight: bold;letter-spacing: 1px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blackGreen};
`;
